import userService from '@/service/userService'
import axios from 'axios'
import MainPresenter from "@/service/MainPresenter"
import appConfig from '@/service/config'
import moment from 'moment'
import un from 'underscore'
import { escapeParam } from "@/service/UrlEncoder"

const mainPresenter = new MainPresenter();

const SERVICE_STATUSES = {
    "ACCEPTED_FOR_SERVICE": "Przyjęty",
    "IN_SERVICE": "Serwis",
    "RETURNED_FROM_SERVICE": "Odebrany",
    "NOT_PICKED": "Nie odebrany"
}

const COLOR_SERVICE_STATUSES = {
    "ACCEPTED_FOR_SERVICE": "red-font",
    "NOT_PICKED": "red-font",
    "IN_SERVICE": "orange-font",
    "RETURNED_FROM_SERVICE": "torre-green"
}

const ServicesManager = function() {

    this.serviceStatuses = function() {
        const result = []
        for (var key in SERVICE_STATUSES) {
            if (SERVICE_STATUSES.hasOwnProperty(key)) {
                result.push({
                    id: key,
                    name: SERVICE_STATUSES[key]
                })
            }
        }
        return result
    }

    function buildParamsSearch(requestData) {
        return {
            "phoneName": requestData.params.phoneName,
            "reasonKey": requestData.params.reasonKey,
            "storeId": requestData.params.storeId,
            "itemsPage": requestData.pageable.page,
            "itemsSize": 60
        }
    }

    this.searchServices = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: mainPresenter.getUrlForParams("/services/search", buildParamsSearch(requestData)),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.loadConfig = function(onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: `${appConfig.baseUrl}/services/config`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.loadService = function(id, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: `${appConfig.baseUrl}/services/${id}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.isAdmin = function() {
        return userService.isAdmin()
    }

    function buildParamsAddServices(requestData) {
        return {
            storeId: requestData.storeId,
            phoneNameId: requestData.phoneNameId,
            serviceReason: requestData.serviceReason,
            customerContact: requestData.customerContact,
            acceptanceDate: moment(requestData.acceptanceDate).format("YYYY-MM-DD HH:mm:ss"),
            servicePrice: requestData.servicePrice,
            comments: requestData.comments,
            serviceRepairPrice: requestData.serviceRepairPrice,
            serviceStatus: requestData.serviceStatus
        }
    }

    this.addService = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/services',
            data: buildParamsAddServices(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    function buildParamsUpdateServices(requestData) {
        return {
            storeId: requestData.storeId,
            phoneNameId: requestData.phoneNameId,
            serviceReason: requestData.serviceReason,
            customerContact: requestData.customerContact,
            acceptanceDate: moment(requestData.acceptanceDate).format("YYYY-MM-DD HH:mm:ss"),
            servicePrice: requestData.servicePrice,
            comments: requestData.comments,
            serviceRepairPrice: requestData.serviceRepairPrice,
            serviceStatus: requestData.serviceStatus
        }
    }

    this.updateService = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + `/services/edit/${requestData.serviceId}`,
            data: buildParamsUpdateServices(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    function filterStores(stores, currentStoreId) {
        return un.filter(stores, store => {
            return store.id === currentStoreId
        })
    }

    this.initStores = function(onSuccess) {
        axios.get(mainPresenter.buildUrlWithDefaults("/allStores?visible=true")).then(response => {
            const currentStore =  userService.getCurrentStore();
            const stores = response.data.content
            if (this.isAdmin() || userService.isUserPhoneServices()) {
                onSuccess(stores, currentStore);
            } else {
                onSuccess(filterStores(stores, currentStore), currentStore)
            }
            
        }, err => {
            console.log(err)
        })
    }

    this.searchPhoneNames = function(term, handler) {
        var pageable = {
            "itemsPage": 0,
            "itemsSize": 40,
            "sort": "name,asc"
        }
        const req = axios({
          method: 'get',
          url: mainPresenter.getUrlForCommonData(
              "/phoneNames/search",
              { phoneName: escapeParam(term) },
              pageable),
          headers: {
            Authorization: userService.getAuthHeader()
          }
        })
        req.then(res => {
            handler(res.data)
        }).catch(e => {
            console.log(e)
        })
    }

    this.searchPhoneNamesMapper = function(data) {
        return un.map(data.phoneNames, item => {
            console.log(item)
            return {
                id: item.id,
                name: item.name
            }
        })
    }

    this.formatDate = function(itemDate) {
        return moment(itemDate).format("YYYY-MM-DD")
    }

    this.formatPrice = function(itemPrice) {
        return itemPrice.toString() + " zł"
    }

    this.deleteService = function(id, onSuccess, onError) {
        const req = axios({
            method: 'delete',
            url: `${appConfig.baseUrl}/services/${id}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.isNotUserPhoneServices = function() {
        return !userService.isUserPhoneServices()
    }

    return {
        "isAdmin": this.isAdmin,
        "searchServices": this.searchServices,
        "addService": this.addService,
        "initStores": this.initStores,
        "searchPhoneNames": this.searchPhoneNames,
        "searchPhoneNamesMapper": this.searchPhoneNamesMapper,
        "loadConfig": this.loadConfig,
        "formatDate": this.formatDate,
        "formatPrice": this.formatPrice,
        "loadService": this.loadService,
        "updateService": this.updateService,
        "deleteService": this.deleteService,
        "isNotUserPhoneServices": this.isNotUserPhoneServices,
        "serviceStatuses": this.serviceStatuses,
        "rawStatuses": SERVICE_STATUSES,
        "colorStatuses": COLOR_SERVICE_STATUSES
    }
}

export default ServicesManager;


// WEBPACK FOOTER //
// ./src/components/service/ServicesManager.js